// @flow

import {Paper} from 'material-ui';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as AuthActions from '../../actions/auth';
import Navbar from '../../components/Navbar/Navbar';
import {RankingReport} from '../../components/RankingReport/RankingReport';
import './Dashboard.css';

class Dashboard extends Component {

  componentWillMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.actions.logout();
    }
  }

  render() {
    const {auth} = this.props;

    if (!auth.isAuthenticated) {
      return null;
    }

    return (
      <main className="dashboard">
        <Navbar/>
        <div className="container">
          <Paper
            className="dashboard__paper"
            zDepth={1}
          >
            <section className="dashboard__greeting">
              <h1 className="dashboard__greeting-header">Hello {auth.profile.name}!</h1>
              <div>
                Personal Marketing Consultant:
                {
                  auth.profile.provisioner ? (
                    <a href={`mailto:${auth.profile.provisioner_email}`} target="_blank">{auth.profile.provisioner}</a>
                  ) : <p> Not assigned yet. Please check back in a moment!</p>
                }
              </div>
            </section>

            <section className="dashboard__account">
              <section className="dashboard__business">
                <h3>Business Information</h3>
                <div className="dashboard__business-info">
                  <div>Package Type:</div>
                  <div>{auth.profile.package_type}</div>
                </div>
                <div className="dashboard__business-info">
                  <div>Business Name:</div>
                  <div>{auth.profile.business}</div>
                </div>
                <div className="dashboard__business-info">
                  <div>Address:</div>
                  <div><a href={`https://maps.google.com/?1=${auth.profile.address}`}
                          target="_blank">{auth.profile.address}</a></div>
                </div>
                <div className="dashboard__business-info">
                  <div>Phone:</div>
                  <div><a href={`tel:${auth.profile.phone}`}
                          target="_blank">{auth.profile.phone}</a></div>
                </div>
                <div className="dashboard__business-info">
                  <div>Call Tracking Number:</div>
                  <div><a href="tel:123-123-1234" target="_blank">{auth.profile.call_tracking_number}</a>
                  </div>
                </div>
                <div className="dashboard__business-info">
                  <div>Email:</div>
                  <div><a href={`mailto:${auth.profile.email}`}
                          target="_blank">{auth.profile.email}</a>
                  </div>
                </div>
                <div className="dashboard__business-info">
                  <div>Website:</div>
                  <div><a href={`${auth.profile.website}`}
                          target="_blank">{auth.profile.website}</a></div>
                </div>
              </section>

              <section className="dashboard__cities">
                <h3>Cities</h3>
                <ul className="dashboard__list">
                  {
                    auth.profile.cities.map((city, index) => {
                      return (
                        <li key={index}>{city}</li>
                      )
                    })
                  }
                </ul>
              </section>

              <section className="dashboard__keywords">
                <h3>Keywords</h3>
                <ul className="dashboard__list">
                  {
                    auth.profile.keywords.map((keyword, index) => {
                      return (
                        <li key={index}>{keyword}</li>
                      )
                    })
                  }
                </ul>
              </section>
            </section>

            <section>
              <RankingReport src={auth.profile.ranking_report}/>
            </section>

            <section className="dashboard__contact">
              <h1>Have questions or need help?</h1>
              <p>Email us at <a href="mailto:help@gozoek.com" target="_blank">help@gozoek.com</a> or get in contact with
                your <a href={`mailto:${auth.profile.provisioner_email}`} target="_blank">Personal
                  Consultant</a></p>
            </section>
          </Paper>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(AuthActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/Dashboard/Dashboard.js